export default __webpack_public_path__ + "static/media/project1.7ba4b29e.png";